import { render } from "./reportecamas.vue?vue&type=template&id=533bbae4&scoped=true"
import script from "./reportecamas.vue?vue&type=script&lang=js"
export * from "./reportecamas.vue?vue&type=script&lang=js"

import "./reportecamas.vue?vue&type=style&index=0&id=533bbae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533bbae4"]])

export default __exports__